import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { useEffect, useState } from "react";
import TestimonialsCard from "./TestimonialsCard";
import { get, post } from "utilities/requests";

const absolute_button_style = {
  gap: "0.4rem",
  padding: "0.4rem 1rem",
  // backgroundColor: "#84eb7f",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  borderRadius: "0.4rem",
  border: "none",
  color: "black",
};

const Testimonials = () => {
  const [save_button_icon, setSave_button_icon] = useState({
    status: "Salvar tudo",
    icon: <SaveIcon />,
  });

  const [readyToRender, setReadyToRender] = useState(false);
  const [testimonials, setTestimonials] = useState([]);

  const addTestimonial = () => {
    setTestimonials([
      ...testimonials,
      {
        name: "",
        title: "",
        text: "",
        avatar: "",
        occupation: "",
      },
    ]);
  };

  const removeTestimonial = (index) => {
    let temp = [...testimonials];
    temp.splice(index, 1)

    setTestimonials(temp);
  };

  const handleTestimonialChange = (index, data) => {
    let temp = [...testimonials];
    temp[index].title =
      data.title !== undefined ? data.title : temp[index].title;
    temp[index].name = data.name !== undefined ? data.name : temp[index].name;
    temp[index].text = data.text !== undefined ? data.text : temp[index].text;
    temp[index].avatar =
      data.avatar !== undefined
        ? data.avatar
        : temp[index].avatar;
    temp[index].occupation =
      data.occupation !== undefined ? data.occupation : temp[index].occupation;
    setTestimonials(temp);
  };

  const saveTestimonials = async () => {
    setSave_button_icon({
      status: "Salvando...",
      icon: <HourglassTopRoundedIcon />,
    });

    const form = new FormData()

    testimonials.forEach(data => {
      let data2 = {...data}
      data2.avatar_path = data.avatar
      delete data2.avatar

      form.append("testimonials[]", JSON.stringify(data2));
    });

    let response = await post(`testimonials/save`, form);

    setTimeout(() => {
      if (response.httpCode === 200) {
        setSave_button_icon({
          status: "Salvo!",
          icon: <CheckRoundedIcon />,
        });
        setTimeout(() => {
          setSave_button_icon({
            status: "Salvar tudo",
            icon: <SaveIcon />,
          });
        }, 3000);
      } else {
        alert(response.message);
        setSave_button_icon({
          status: "Erro ao salvar",
          icon: <SaveIcon />,
        });
        setTimeout(() => {
          setSave_button_icon({
            status: "Salvar tudo",
            icon: <SaveIcon />,
          });
        }, 3000);
      }
    }, 500);
  };

  const getto = async () => {
    const res = await get(`testimonials`);

    if (res.httpCode === 200) {
      // setTestimonials(res.testimonials);
      let temp_testimonials = res.testimonials.map((data) => {
        return {
          name: data.name,
          title: data.title,
          text: data.text,
          avatar: data.avatar_path,
          occupation: data.occupation,
        };
      });
      setTestimonials(temp_testimonials);
      setReadyToRender(true);
    }
  };

  useEffect(() => {
    getto().catch((e) => {
      console.log(e);
    });
  }, []);

  return (
    readyToRender && (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          height: "100%",
          gap: "2rem",
          fontFamily: "var(--Raleway)",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "fixed",
            top: "5rem",
            right: "1rem",
            zIndex: "4",
            display: "flex",
            gap: "2rem",
          }}
        >
          <button
            style={{ ...absolute_button_style, backgroundColor: "#b3c3c7" }}
            onClick={addTestimonial}
          >
            <AddIcon /> Adicionar
          </button>
          <button
            style={{ ...absolute_button_style, backgroundColor: "#84eb7f" }}
            onClick={saveTestimonials}
          >
            {save_button_icon.icon} {save_button_icon.status}
          </button>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            gap: "2rem",
            width: "100%",
          }}
        >
          {testimonials.map((user, index) => (
            <TestimonialsCard
              key={index}
              index={index}
              remove={removeTestimonial}
              change={handleTestimonialChange}
              title={user.title}
              text={user.text}
              avatar={user.avatar}
              name={user.name}
              occupation={user.occupation}
            />
          ))}
        </div>
      </div>
    )
  );
};

export default Testimonials;
